'use client';
import { Button, Modal, toast } from '@ethsign/ui';

import React from 'react';

import { ColorShieldIcon } from '@/components';

import { sendMailToRecipients } from '@/services';
import { IContact } from '@/types';

import { EmailInput } from '../TextField/EmailInput';

export const InviteViewersModal = ({
  open,
  onOpenChange,
  contractId
}: {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  contractId: string;
}) => {
  const [data, setData] = React.useState<IContact[]>([]);
  const [loading, setLoading] = React.useState(false);
  return (
    <>
      <Modal
        open={open}
        onOpenChange={(open) => {
          if (!open) {
            setData([]);
          }
          onOpenChange(open);
        }}
        maskClosable={false}
        footer={<div></div>}
        className={'md:w-[540px]'}
      >
        <div className="flex  flex-col justify-center">
          <ColorShieldIcon />
          <div className="text-lg font-medium text-gray-900 mt-[20px]">Add Viewer</div>
          <div className="text-sm text-gray-500 mt-[8px] mb-[20px] ">
            Enter the email addresses to grant viewing access to the contract. A notification will be sent via email,
            and you will need to provide the password separately.
          </div>
          <div className="flex items-start justify-between gap-2">
            <EmailInput data={data} onChange={setData} />
            <Button
              loading={loading}
              variant={'primary'}
              onClick={async () => {
                try {
                  setLoading(true);
                  await sendMailToRecipients({
                    contractId,
                    mailto: data.map((item) => item.email).join(',')
                  });
                  toast({
                    title: 'Success',
                    variant: 'success',
                    description: 'Mail sent successfully'
                  });
                  setData([]);
                  onOpenChange(false);
                  setLoading(false);
                } catch (error) {
                  setLoading(false);
                  toast({
                    title: 'Error',
                    variant: 'error',
                    description: 'Failed to send mail'
                  });
                }
              }}
              disabled={data.length === 0}
            >
              <span className="ml-2">Invite</span>
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
